import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { makeStyles } from '@material-ui/core/styles';
import { validateDevice, registerDevice } from '../../redux/users/usersActions';
import { notify } from '../../redux/utils/notifications/notifications';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Fingerprint from 'fingerprintjs';
import logo from '../../assets/SciataLogoDark.png';
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  TextField,
  Zoom,
} from '@material-ui/core';
import { getCookie, createCookie, deleteCookie } from '../../redux/utils/customMethods';

const pageTitle = 'Login';
const fingerprint = new Fingerprint().get();
const cookieName = 'user_token';

const useStyles = makeStyles(theme => ({
  pageContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexGrow: 1,
    alignContent: 'center',
    justifyContent: 'center',
    // backgroundColor: '#2323B5',
    margin: 0,
    padding: 0
   
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& > *': {
      margin: theme.spacing(1),
      width: '35ch',
    },
  },
  loginButton: {
    margin: theme.spacing(2),
    color: theme.palette.common.white,
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  inputMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',

      // "&:hover": {
      //     backgroundColor: theme.palette.secondary.dark,
      // },
    },
    [theme.breakpoints.up('md')]: {
      // "&:hover": {
      //     backgroundColor: theme.palette.secondary.dark,
      // },
    },
  },
  btnMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
}));

const TextMaskCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '1',
        '-',
        /[1-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder='1-555-555-5555'
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const LoginPage = props => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mobile, setMobile] = useState('');
  const [checked, setChecked] = useState(false);
  const [statusCode, setStatusCode] = useState('');
  const [user, setUser] = useState({ status: undefined });

  const dispatch = useDispatch();
  const classes = useStyles();

  const loginCreds = {
    emailId: email,
    enteredOtp: password,
    mobile: mobile.indexOf(' ') >= 0 ? '' : mobile,
    deviceId: fingerprint,
    userToken: '',
  };

  useEffect(() => {
    document.title = 'Sciata Login';
    deleteCookie(cookieName);
    checkRegisterDetails();
  });

  const handleVerify = async e => {
    const response = await dispatch(validateDevice(loginCreds));

    if (response && response.data) {
      switch (response.data.statusCode) {
        case 200:
          authenticateUser(response.data);
          break;
        case 422:
          notify('info', response.data.statusMsg);
          setUser({ status: '101' });
          break;
        default:
          notify('error', response.data.statusMsg);
          setUser({ status: undefined });
          break;
      }
      setChecked(prev => !prev);
    } else {
      notify('Something went wrong.');
      setUser({ status: undefined });
    }
  };

  const handleLogin = async () => {
    const response = await dispatch(registerDevice(loginCreds));
    if (response.data.statusCode === 200) {
      authenticateUser(response.data);
    }
  };

  const authenticateUser = async respData => {
    const cookieData = {
      token: respData.userToken,
      user: respData.user.emailId,
    };

    createCookie(
      cookieName,
      JSON.stringify({
        userToken: cookieData.token,
        user: cookieData.user,
      }),
      365
    );

    if (respData.user.role === 'admin'|| respData.user.role==='clientManager') {
      props.history.push('/admin/approvals');
    } else {
      props.history.push('/timesheet');
    }
  };

  const checkRegisterDetails = async () => {
    let _cookieContent = getCookie(cookieName);
    try {
      _cookieContent = JSON.parse(_cookieContent);

      if (_cookieContent) {
        loginCreds.deviceId = fingerprint;
        loginCreds.userToken = _cookieContent.userToken;
        loginCreds.emailId = _cookieContent.user;
        const response = await dispatch(validateDevice(loginCreds));

        if (response && response.data.statusCode === 200) {
          authenticateUser(response.data);
        } else {
          deleteCookie(cookieName);
        }
      }
    } catch (ex) {
      _cookieContent = undefined;
      deleteCookie(cookieName);
    }
  };

  return (
    <div className={classes.pageContainer}>
      {user.status !== '101' ? (
        <Zoom in={user.status !== '101'}>
          <div className={classes.contentContainer} >
            <img alt='sciata-logo' src={logo} />
            <TextField
              style={{ backgroundColor: 'white' }}
              id='filled-email-input'
              label='Email'
              variant='outlined'
              className={classes.inputMobile}
              type='email'
              name='email'
              autoComplete='email'
              onChange={e => setEmail(e.target.value)}
              value={email}
              required
            />
            <FormControl
              className={classes.inputMobile}
              style={{ backgroundColor: 'white' }}
            >
              <TextField
                value={mobile}
                label='Phone Number'
                onChange={e => setMobile(e.target.value)}
                variant='outlined'
                id='formatted-text-mask-input'
                InputProps={{
                  inputComponent: TextMaskCustom,
                }}
              />
            </FormControl>
            <Button
              className={classes.btnMobile}
              color='inherit'
              variant='outlined'
              type='submit'
              checked={checked}
              onClick={handleVerify}
              disabled={!email && !mobile}
            >
              verify
            </Button>
            {user.status && user.status !== '101' && (
              <div style={{ color: 'red', marginTop: '10px' }}>
                Enter valid email/mobile
              </div>
            )}
          </div>
        </Zoom>
      ) : (
        <Zoom
          in={user.status === '101'}
          style={{ transformOrigin: '0 0 0' }}
          enter={user.status === '101'}
        >
          <div className={classes.contentContainer}>
            <img alt='techmileage-logo' src={logo} />
            <h2>{email}</h2>
            <h2>{mobile}</h2>
            <TextField
              id='standard-password-input'
              label='Please enter otp'
              variant='outlined'
              type='password'
              autoComplete='current-password'
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <Button
              className={classes.loginButton}
              color='inherit'
              variant='outlined'
              type='submit'
              onClick={handleLogin}
              disabled={!password}
            >
              login
            </Button>
            {statusCode && statusCode === '104' && (
              <div style={{ color: 'red', marginTop: '10px' }}>Enter valid OTP</div>
            )}
          </div>
        </Zoom>
      )}
    </div>
  );
};

export default withRouter(LoginPage);
